import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-cookie-consent',
    templateUrl: './cookie-consent.component.html',
    styleUrl: './cookie-consent.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CookieConsentComponent {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<CookieConsentComponent>>(MatDialogRef);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {}

}
